export const MALE = 'MALE';
export const FEMALE = 'FEMALE';
export const MALE_TITLES = [{ code: 'Mr', description: 'Mr', displayOrder: 1 }];
export const FEMALE_TITLES = [
    { code: 'Mrs', description: 'Mrs', displayOrder: 2 },
    { code: 'Miss', description: 'Miss', displayOrder: 3 },
];
export const ALL_TITLES = [...MALE_TITLES, ...FEMALE_TITLES];
export const EFP_RELATIONSHIP_GENDERS = {
    aunt: FEMALE,
    brother: MALE,
    brotherInLaw: MALE,
    child: null,
    cousin: null,
    daughter: FEMALE,
    daughterInLaw: FEMALE,
    father: MALE,
    fatherInLaw: MALE,
    friend: null,
    grandchildren: null,
    grandparent: null,
    me: null,
    mother: FEMALE,
    motherInLaw: FEMALE,
    nephew: MALE,
    niece: FEMALE,
    sister: FEMALE,
    sisterInLaw: FEMALE,
    son: MALE,
    sonInLaw: MALE,
    uncle: MALE,
    spouse: null,
    parentInLaw: null,
    stepParent: null,
    grandparentInLaw: null,
};
export const EFP_RELATIONSHIP_GENDERS_ALTERNATE_KEYS = Object.fromEntries(
    Object.entries(EFP_RELATIONSHIP_GENDERS).map(([key, val]) => [key.toLowerCase(), val])
);

export const RELATIONS = Object.freeze({
    MYSELF: 'Myself',
    CHILD: 'Child',
    SPOUSE: 'Spouse',
    WIFE: 'Wife',
});
export const EFP_QUOTE_DIRECT_FAMILY_SCROLL_ID = ['age', 'addChild', 'addPartner'];

export const ADDRESS_TYPES = {
    PRIVATE_BAG: 'PrivateBag',
    PO_BOX: 'POBox',
    STREET_ADDRESS: 'StreetAddress',
};

export const PRODUCT_DETAIL_URL = '/personal/ka-metlha-funeral-cover/';
export const KMF_APP_URL_PREFIX = '/ka-metlha-funeral-cover';
export const APP_NOT_INITIATED = 'APP_NOT_INITIATED';

export const PAGES = [
    {
        URL: `${KMF_APP_URL_PREFIX}/replacement-policy/`,
        URL_PART: 'replacement-policy',
        TITLE: 'Replacement Policy',
    },
    {
        URL: `${KMF_APP_URL_PREFIX}/personal-details/`,
        URL_PART: 'personal-details',
        TITLE: 'Personal Details',
    },
    {
        URL: `${KMF_APP_URL_PREFIX}/lives-covered/`,
        URL_PART: 'lives-covered',
        TITLE: 'Lives Covered',
    },
    {
        URL: `${KMF_APP_URL_PREFIX}/beneficiaries/`,
        URL_PART: 'beneficiaries',
        TITLE: 'Beneficiaries',
    },
    {
        URL: `${KMF_APP_URL_PREFIX}/payment-details/`,
        URL_PART: 'payment-details',
        TITLE: 'Payment Details',
    },
    {
        URL: `${KMF_APP_URL_PREFIX}/upload-documents/`,
        URL_PART: 'upload-documents',
        TITLE: 'Upload Documents',
    },
    {
        URL: `${KMF_APP_URL_PREFIX}/confirmation/`,
        URL_PART: 'confirmation',
        TITLE: 'Confirmation',
    },
    {
        URL: `${KMF_APP_URL_PREFIX}/thank-you/`,
        URL_PART: 'thank-you',
        TITLE: 'Thank You',
    },
];

export const PAGE_URLS = {
    QUOTE: PRODUCT_DETAIL_URL,
    REPLACEMENT_POLICY: `${KMF_APP_URL_PREFIX}/${PAGES[0].URL_PART}`,
    PERSONAL_DETAILS: `${KMF_APP_URL_PREFIX}/${PAGES[1].URL_PART}`,
    LIVES_COVERED: `${KMF_APP_URL_PREFIX}/${PAGES[2].URL_PART}`,
    BENEFICIARIES: `${KMF_APP_URL_PREFIX}/${PAGES[3].URL_PART}`,
    PAYMENT_DETAILS: `${KMF_APP_URL_PREFIX}/${PAGES[4].URL_PART}`,
    UPLOAD_DOCUMENTS: `${KMF_APP_URL_PREFIX}/${PAGES[5].URL_PART}`,
    CONFIRMATION: `${KMF_APP_URL_PREFIX}/${PAGES[6].URL_PART}`,
    THANK_YOU: `${KMF_APP_URL_PREFIX}/${PAGES[7].URL_PART}`,
};

export const PAGE_INDICES = {
    REPLACEMENT_POLICY: 0,
    PERSONAL_DETAILS: 1,
    LIVES_COVERED: 2,
    BENEFICIARIES: 3,
    PAYMENT_DETAILS: 4,
    UPLOAD_DOCUMENTS: 5,
    CONFIRMATION: 6,
    THANK_YOU: 7,
};

export const fileTypeIcons = {
    jpg: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt56d6e81d602c99de/6797a371b19afb369b7afda0/File_Icon_JPG.svg',
    jpeg: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blteca5e7feca91f3e6/6797a373b649e6acfd7702ab/File_Icon_JPEG.svg',
    pdf: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt28588d3724fd5c5f/6797a373786c5a20389b1511/File_Icon_PDF.svg',
    tif: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt3b6c0bce2454acfa/6797a3746c6824e35038a066/File_Icon_TIF.svg',
    tiff: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt4e38e3635afb2e77/6797a372274f954ab2ce7426/File_Icon_TIFF.svg',
    png: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt8595e906f89120f7/6797a372274f95371fce7428/File_Icon_PNG.svg',
};

const SIZE_2_MB = 2097152;
const SIZE_1_kb = 1024;

export const UPLOAD_PAGE_CONFIG = {
    MIN_INPUT_SIZE: SIZE_1_kb,
    MIN_INPUT_SIZE_NAME: '1 kb',
    MAX_INPUT_SIZE: SIZE_2_MB,
    MAX_INPUT_SIZE_NAME: '2 mb',
    VALID_UPLOAD_TYPES: [
        { FORMAT: 'image/jpeg', FORMAT_NAME: 'JPG' },
        { FORMAT: 'image/png', FORMAT_NAME: 'PNG' },
        { FORMAT: 'application/pdf', FORMAT_NAME: 'PDF' },
    ],
};

export const KMF_COVER_CATEGORIES = {
    MYSELF: 'Myself',
    ME_AND_MY_DIRECT_FAMILY: 'Me_and_My_Direct_Family',
    PARENTS_AND_IN_LAWS: 'My_Parents_and_In_laws',
    EXTENDED_FAMILY: 'My_Extended_Family',
    LIVES_COVERED_SIDE_DRAWER: 'Lives_Covered_Side_Drawer',
    BENIFITS: 'Benifits',
    LIVES_COVERED_DETAILS_SIDEDRAWER: 'Lives_Covered_Details_Side_Drawer',
    BENEFECIARY: 'Beneficiary',
    ADD_COVER_IN_LIVESCOVERED: 'Add_Cover_In_LivesCovered',
    AGENT: 'Agent',
};

export const titles = {
    Me_and_My_Direct_Family: 'Me & My Direct Family',
    My_Parents_and_In_laws: 'My Parents & In-Laws',
    Myself: 'Main Member',
    My_Extended_Family: 'My Extended Family',
};

export const RADIO_OPTION = {
    YES: 'Yes',
    NO: 'No',
};

export const KMF_POPUP_MODAL = {
    INCOMPLETE_MODAL: 'Incomplete_Modal',
    ADD_BENEFICIARY_MODAL: 'addBeneficiaryModal',
};
